import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {}, // Empty resources, will be populated dynamically
  keySeparator: '.',
  saveMissing: true,
  react: {
    useSuspense: false, // Set to true if you want to use Suspense
  },
  interpolation: {
    escapeValue: false, // Not needed for React as it escapes by default
  },
});

export default i18n;
